import React, { useState, useEffect } from 'react';
import { Toolbar, Tabs, Tab } from '@material-ui/core';
import ProductsGrid from './ProductsGrid';
import Bill from './Bill';
import Tickets from './Tickets';
import logo from '../assets/img/LogoOficial.png';

const Home = () => {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleChangeTab = (event, value) => {
        setSelectedTab(value);
    };
        
    return(
        <div className="full-height">
            <Toolbar className="toolbar-tpv">
                <div className="img-external-border">
                    <div className="img-internal-border">
                        <img className='top-menu-cbx-logo' src={logo} alt="logo"/>
                    </div>
                </div>
                <div style={{marginLeft: '20px', color: 'white'}}>
                    <Tabs value={selectedTab} onChange={handleChangeTab}>
                        <Tab label="TPV" value={0}/>
                        <Tab label="TICKETS" value={1}/>
                    </Tabs>
                </div>
            </Toolbar>
            {selectedTab === 0 ?
                    <div className="container-with-top-menu">
                        <div style={{width:'65%', height:'100%'}}>
                            <ProductsGrid/>
                        </div>
                        <div style={{width:'35%', height:'100%'}}>
                            <Bill/>
                        </div>
                    </div>
                :   
                    <div className="container-with-top-menu">
                        <Tickets />
                    </div>
            }
        </div>
    )
};

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js